import { render } from "./PropertyFilters.vue?vue&type=template&id=545e9c17"
import script from "./PropertyFilters.vue?vue&type=script&lang=js"
export * from "./PropertyFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__